import React, { useEffect, useState, useRef } from "react";
import useHttp from '../../../../hook/use-http';
import NoData from '../NoData';
import ChartLoader from '../ChartLoader';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsFillCalendarCheckFill } from "react-icons/bs";
import moment from 'moment';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import { BsZoomIn } from "react-icons/bs";
import * as $ from 'jquery';
import './Torquespeed.css';

import Chart from 'react-apexcharts'
import WaterMark from "../../DashboardMain/WaterMark";

function Torquespeed({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const [selectedD, setselectedD] = useState(new Date());
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [filterenddata, setFilterendData] = useState({});
  const dateselection = useRef();
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const isMobile = width < 768
  const issmMobile = width < 385;

  let edate
  const appyDataDate = (data) => {
    const res_result = data;
    const setevnetdate = res_result[0].max_eventdate.value_as_string
    edate = moment.parseZone(setevnetdate)
    setselectedD(moment(new Date(edate)).toDate())
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter, selectedDate: edate } }, appyData)
  }

  const appyData = (data) => {
    const res_result = data.result;
    const date_display = data.date_display;
    if (res_result.length != 0) {
      let temp_result = res_result;
      let res_result_final = [{
        name: "Speed Vs Torque",
        data: []
      }]
      let y_data_set = [];
      temp_result.map(x => {
        res_result_final[0].data.push([parseInt(x.fields.MCU_Motor_RPM[0]), parseInt(x.fields.mcu_motor_torque[0])]);

      })
      setChartData((prestate) => res_result_final);
      setselectedD(moment(new Date(date_display)).toDate());
      window.dispatchEvent(new Event('resize'));
    } else {
      setChartData((prestate) => []);
      setselectedD(moment(new Date(date_display)).toDate());
      window.dispatchEvent(new Event('resize'));
    }
  }

  let xvalue, yvalue;
  if (isMobile === true) {
    xvalue = 85; yvalue = 85
  } else {
    xvalue = 85; yvalue = 110
  }

  if (issmMobile === true) {
    xvalue = 110; yvalue = 110
  }

  const chageDateSelection = () => {
    dateselection.current.setFocus();
  }

  const options = {
    chart: {
      toolbar: {
        show: false
      },
      type: 'scatter',

    },
    colors: ["#348393"],
    grid: {
      show: false,
    },
    yaxis: {
      title: {
        text: "Torque(Nm)",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      tickAmount: 7,
      show: true,
    },
    xaxis: {
      position: 'bottom',
      decimalsInFloat: false,
      tickAmount: 10,
      title: {
        text: "Speed(RPM)",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        },
        offsetY: yvalue,
      },
      labels: {
        formatter: function (val) {
          return parseInt(val);
        }
      }
    }
  };
  const options1 = {
    chart: {
      toolbar: {
        show: false
      },
      type: 'scatter',

    },
    colors: ["#348393"],
    grid: {
      show: false,
    },
    yaxis: {
      title: {
        text: "Torque(Nm)",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        }
      },
      tickAmount: 7,
      show: true,
    },
    xaxis: {
      position: 'bottom',
      decimalsInFloat: false,
      tickAmount: 10,
      title: {
        text: "Speed(RPM)",
        style: {
          color: undefined,
          fontSize: '9px',
          fontStyle: "italic",
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 100,
        },
        offsetY: xvalue,
      },
      labels: {
        formatter: function (val) {
          return parseInt(val);
        }
      }
    }
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "drivesecondpagecharts/eventdate", body: { filterdata: { "VIN_NUM": gloablfilter.vin_num } } }, appyDataDate)
  }, [gloablfilter])

  const chnageSelection = (date) => {
    setselectedD(date);
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter, selectedDate: date } }, appyData)
  }

  const rezoom = () => {
    window.$('#torquespeedsecond').modal('show');
    window.dispatchEvent(new Event('resize'));
  }

  return (
    <>
      <div className="modal fade" id="torquespeedsecond" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">Torque Vs Speed<small className="small_torquespee" >(Motor Operating Zone)</small></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ height: "400px" }}>
              <WaterMark />
              {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart options={options1} series={chartdata} type="scatter" width="100%" height="360px" />)}
            </div>
          </div>
        </div>
      </div>

      <div className="v-title chartbox">
        <div className="titlebg" style={{ margin: "0px" }}>Torque Vs Speed <small className="small_torquespee" >(Motor Operating Zone)</small><strong onClick={chageDateSelection} style={{ float: "right" }}> <BsFillCalendarCheckFill /> </strong>
          <strong id="oldpz" style={{ float: "right", cursor: "pointer", marginRight: "5px" }} onClick={rezoom}    > <BsZoomIn /> </strong>
          <DatePicker id="selectdate" ref={dateselection} selected={selectedD} onChange={chnageSelection} dateFormat="dd-MM-yyyy" />
        </div>
        <div className="chartHGT">
          <WaterMark />
          {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart type="scatter" width="100%" height="170px" series={chartdata} options={options} />)}
        </div>
        <div style={{ bottom: "10px", position: "absolute" }}><small style={{ fontSize: "9px", fontWeight: 800 }}>Global filters don't affect on this chart except Vin filter</small></div>
      </div>
    </>
  );
}

export default Torquespeed;